
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";

export function CharityHeader() {
  const { branding } = useChurchBranding();

  const getBackgroundGradient = () => {
    if (branding) {
      return `linear-gradient(135deg, ${branding.primaryColor}, ${branding.secondaryColor})`;
    }
    return 'linear-gradient(135deg, hsl(var(--app-accent)), hsl(var(--app-accent))/0.8)';
  };

  const getCardClasses = () => {
    return "relative flex flex-col md:flex-row items-center gap-5 bg-app-surface/90 backdrop-blur-sm px-8 py-6 rounded-2xl shadow-sm transition-all hover:shadow-md border border-app-border";
  };

  const getTitleColor = () => {
    if (branding?.primaryColor) {
      return branding.primaryColor;
    }
    return "hsl(var(--app-accent))";
  };

  const getDescriptionColor = () => {
    return "text-app-text-secondary";
  };

  return (
    <div className="flex flex-col items-center text-center space-y-6 pb-8 animate-fade-in" style={{ animationDuration: "0.6s" }}>
      <div className="relative">
        <div 
          className="absolute inset-0 blur-xl opacity-50 rounded-full transform -translate-y-1/2 transition-all duration-300"
          style={{ background: getBackgroundGradient() }}
        />
        <div className={getCardClasses()}>
          {branding?.logoUrl ? (
            <img 
              src={branding.logoUrl}
              alt={`${branding.churchName} Logo`}
              className="h-20 w-auto transform hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <img 
              src="/lovable-uploads/97cec83c-b4fa-48c3-a12a-a678346efa1f.png" 
              alt="Logo" 
              className="h-20 w-auto transform hover:scale-105 transition-transform duration-300"
            />
          )}
          <div className="mt-4 md:mt-0">
            <h1 className="text-4xl font-bold tracking-tight transition-colors duration-300" 
                style={{ color: getTitleColor() }}>
              Give
            </h1>
            <p className={`${getDescriptionColor()} max-w-md mt-2 transition-colors duration-300`}>
              Support our mission and make a difference
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
